import { useQuery } from '@apollo/client/react';
import { GET_PROJECTS } from '../graphql/queries';
import { Project } from '../types/Project';

interface ProjectsData {
  getProjectsForAdminPanel: Project[];
}

export const useProjects = () => {
  const { data, loading, error, refetch } = useQuery<ProjectsData>(GET_PROJECTS);

  return {
    projects: data?.getProjectsForAdminPanel || [],
    loading,
    error,
    refetch,
  };
};
